import React from 'react';
import { categoryGauge } from '../../../utils/adverseMediaSubjectIndicators';

function CategoryGauge({ label, level, concern = false, displayLabel }) {
  const gauge = categoryGauge(level);
  const valueText = displayLabel || gauge.label;
  return <div className="kycAdverseCategoryGauge" data-indicator={label}>
    <div className="text-muted small">{label}</div>
    <div className="progress kycIndicatorTrack" role="meter" aria-label={label}
      aria-valuemin={0} aria-valuemax={3} aria-valuenow={gauge.rank ?? 0} aria-valuetext={valueText}>
      <div className={`progress-bar kycAdverseCategoryFill ${concern ? `is-${level}` : ''}`}
        style={{ width: `${gauge.fill}%` }} />
    </div>
    <div className="small fw-semibold text-end">{valueText}</div>
  </div>;
}

export default function AdverseMediaSubjectIndicators({ indicators }) {
  const { article, concern } = indicators;
  const absent = concern === 'none' ? 'none' : 'unavailable';
  return <div className="kycAdverseHighestArticle">
    <div className="fw-semibold" style={{ marginBottom: 30 }}>Highest-concern article</div>
    <div className="d-flex flex-column gap-2">
      <CategoryGauge label="Overall concern" level={concern} concern />
      <div className="kycAdverseGaugeSeparator" />
      <CategoryGauge label="AML severity" level={article?.severity || absent} />
      <CategoryGauge label="Name match" level={article?.nameMatch || absent} />
      <CategoryGauge label="Source quality" level={article?.sourceQuality || absent}
        displayLabel={article?.sourceQuality === 'review' ? 'Uncertain' : undefined} />
      <div className="kycAdverseCategoryGauge" data-indicator="Subject implicated">
        <div className="text-muted small">Subject implicated</div>
        <div className="progress kycIndicatorTrack" aria-hidden="true">
          <div className="progress-bar kycAdverseCategoryFill" style={{ width: article?.implicated === true ? '100%' : '0%' }} />
        </div>
        <div className="small fw-semibold text-end">{article?.implicated === true ? 'Yes'
          : article?.implicated === false ? 'No' : article ? 'Review needed' : categoryGauge(absent).label}</div>
      </div>
    </div>
    {article?.reviewRequired ? <div className="kycAdverseArticleReviewFooter">
      <div className="kycAdverseArticleReviewBadge">
        <i className="bi bi-exclamation-circle" aria-hidden="true" />
        <div>
          <div className="kycAdverseArticleReviewTitle">Manual review is critical</div>
          {article.reviewReasons.length > 1 ? (
            <ul className="kycAdverseArticleReviewHint kycAdverseArticleReviewReasons">
              {article.reviewReasons.map(reason => <li key={reason}>{reason}</li>)}
            </ul>
          ) : <div className="kycAdverseArticleReviewHint">{article.reviewReasons[0]}</div>}
        </div>
      </div>
    </div> : null}
  </div>;
}
